import React, { useState } from 'react';
import { FolderIcon, FolderOpenIcon, ChevronRightIcon } from 'lucide-react';
import { Folder, Document } from '../types/documents';
import { DocumentRow } from './DocumentRow';
interface FolderRowProps {
  folder: Folder;
  documents: Document[];
  folders?: Folder[];
  onViewDocument: (doc: Document) => void;
  isExpandedInitially?: boolean;
  onMoveDocument?: (docId: string, folderId: string | undefined) => void;
}
export function FolderRow({
  folder,
  documents,
  folders = [],
  onViewDocument,
  isExpandedInitially = false,
  onMoveDocument
}: FolderRowProps) {
  const [isExpanded, setIsExpanded] = useState(isExpandedInitially);
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const folderDocuments = documents.filter(doc => doc.folderId === folder.id);
  const documentCount = folderDocuments.length;
  return <div className="flex flex-col border-b border-[#DDDBDA] last:border-b-0" data-id="element-90">
      {/* Folder Header */}
      <div className="group flex items-center justify-between py-3 px-6 hover:bg-[#F9F9F9] transition-colors duration-200 cursor-pointer" onClick={toggleExpand} data-id="element-91">
        <div className="flex items-center space-x-4 flex-1 min-w-0" data-id="element-92">
          <div className="flex-shrink-0" data-id="element-93">
            <div className="w-8 h-10 bg-[#FFF8E1] rounded flex items-center justify-center border border-[#DD7A01]/20" data-id="element-94">
              {isExpanded ? <FolderOpenIcon className="w-5 h-5 text-[#DD7A01]" aria-hidden="true" data-id="element-95" /> : <FolderIcon className="w-5 h-5 text-[#DD7A01]" aria-hidden="true" data-id="element-96" />}
            </div>
          </div>
          <div className="flex flex-col min-w-0 flex-1" data-id="element-97">
            <h4 className="text-sm font-semibold text-[#181818] truncate group-hover:text-[#0176D3] transition-colors" data-id="element-98">
              {folder.name}
            </h4>
            <div className="flex items-center text-xs text-[#706E6B] mt-1" data-id="element-99">
              <span data-id="element-100">
                {documentCount} document{documentCount !== 1 ? 's' : ''}
              </span>
            </div>
          </div>
        </div>

        <div className="flex items-center ml-4 flex-shrink-0" data-id="element-101">
          <div className={`p-1 rounded-full text-[#706E6B] group-hover:bg-[#F3F3F3] transition-all duration-200 ${isExpanded ? 'rotate-90' : ''}`} data-id="element-102">
            <ChevronRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-103" />
          </div>
        </div>
      </div>

      {/* Expanded Documents */}
      {isExpanded && folderDocuments.length > 0 && <div className="flex flex-col bg-[#FAFAF9] border-t border-[#DDDBDA]/50" data-id="element-104">
          {folderDocuments.map(doc => <DocumentRow key={doc.id} document={doc} onView={onViewDocument} isNested={true} folders={folders} onMoveDocument={onMoveDocument} data-id="element-105" />)}
        </div>}

      {isExpanded && folderDocuments.length === 0 && <div className="py-4 px-12 text-sm text-[#706E6B] italic bg-[#FAFAF9] border-t border-[#DDDBDA]/50" data-id="element-106">
          This folder is empty
        </div>}
    </div>;
}